import modsky1 from './modsky1';

export const getModSky1InternalCreativeIds = () => new Set(modsky1[Odigeo.SessionScope.website]) || [];

